import type { ChatMode } from '../types/chat-mode';

/**
 * 채팅 모드 설정 상수
 */

export const DEFAULT_CHAT_MODE: ChatMode = 'voice';

export const MODE_CONFIG = {
  // 모드별 기본 설정
  voice: {
    useMicrophone: true,
    showKeyboard: false,
    enableVAD: true,
  },
  chat: {
    useMicrophone: false,
    showKeyboard: true,
    enableVAD: false,
  },
} as const;

export const MODE_LABELS: Record<ChatMode, string> = {
  voice: '음성 모드',
  chat: '텍스트 채팅 모드',
};

export const MODE_ICONS: Record<ChatMode, string> = {
  voice: '🎤',
  chat: '⌨️',
};
